/*
  Free gift line item.

  Every product description promises a free 1 oz travel mist with every order, so
  the cart has to actually contain one. This keeps the cart honest:

    - at least one paid item in the cart  ->  exactly one gift line
    - no paid items                       ->  no gift line

  The gift is a real $0 product, so it reaches the order and the packing slip
  rather than being a note nobody reads.

  It runs on page load and after any cart write. Cart writes go through fetch in
  Dawn, so fetch is wrapped rather than guessing at Dawn's internal events.
  Reconcile calls are serialised and the wrapper ignores this file's own writes,
  which is what stops a loop.
*/
(function () {
  'use strict';

  var GIFT_VARIANT_ID = 47865138511956;
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var running = false;   // a reconcile pass is in flight
  var internal = false;  // the in-flight request is ours, so do not react to it

  function getCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' },
    }).then(function (r) { return r.json(); });
  }

  function write(url, body) {
    internal = true;
    return fetch(window.Shopify.routes.root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); }).finally(function () { internal = false; });
  }

  // Re-render whatever is showing the cart. On the cart page the simplest correct
  // thing is a reload; elsewhere the drawer and the bubble are swapped in place.
  function refreshUi() {
    if (/\/cart($|\?)/.test(window.location.pathname + window.location.search)) {
      window.location.reload();
      return Promise.resolve();
    }
    return fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        Object.keys(sections).forEach(function (name) {
          var incoming = new DOMParser().parseFromString(sections[name], 'text/html');
          var source = incoming.querySelector('#shopify-section-' + name) || incoming.body.firstElementChild;
          var target = document.getElementById('shopify-section-' + name);
          if (source && target) target.innerHTML = source.innerHTML;
        });
      })
      .catch(function () { /* the cart is still correct even if the UI lags */ });
  }

  function reconcile() {
    if (running) return Promise.resolve();
    running = true;

    return getCart()
      .then(function (cart) {
        var paid = 0;
        var giftQty = 0;
        var giftKey = null;

        cart.items.forEach(function (item) {
          if (item.variant_id === GIFT_VARIANT_ID) {
            giftQty += item.quantity;
            giftKey = item.key;
          } else {
            paid += item.quantity;
          }
        });

        if (paid > 0 && giftQty === 0) return write('cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] }).then(refreshUi);
        if (paid > 0 && giftQty > 1) return write('cart/change.js', { id: giftKey, quantity: 1 }).then(refreshUi);
        if (paid === 0 && giftQty > 0) return write('cart/change.js', { id: giftKey, quantity: 0 }).then(refreshUi);
        return null;
      })
      .catch(function () { /* never block the customer over a free gift */ })
      .finally(function () { running = false; });
  }

  var nativeFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : (url && url.url) || '';
    var isCartWrite = CART_WRITE.test(href) && !internal;

    var result = nativeFetch.apply(this, arguments);
    if (!isCartWrite) return result;

    return result.then(function (response) {
      // let Dawn finish its own rendering first, then put the gift back
      setTimeout(reconcile, 300);
      return response;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
